import { Link } from "react-router-dom";
import { CartCountBadge } from "@/components/layout/CartCountBadge";
import { useCartItemCount } from "@/lib/cart";

interface TabItem {
  label: string;
  href: string;
  icon: string;
}

const TABS: TabItem[] = [
  { label: "Accueil", href: "/", icon: "⌂" },
  { label: "Catégories", href: "/catalogue", icon: "☰" },
  { label: "Recherche", href: "/recherche", icon: "\u{1F50D}" },
  { label: "Panier", href: "/panier", icon: "\u{1F6D2}" },
  { label: "Compte", href: "/compte", icon: "\u{1F464}" },
];

/**
 * Barre d'onglets basse mobile (VVS_MODELE_INTERFACE.md §1.11) : cinq onglets
 * fixes, visibles uniquement sous le seuil structurant 1024px. Porté depuis
 * apps/web/components/layout/MobileTabBar.tsx (Server Component avec
 * `getCartItemCount()`) — devenu un composant client utilisant
 * `useCartItemCount()` (TanStack Query, cf. src/lib/cart.ts), plus de rendu
 * serveur possible dans ce SPA.
 */
export function MobileTabBar() {
  const cartItemCount = useCartItemCount();

  return (
    <nav
      aria-label="Navigation principale mobile"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-5 border-t border-line bg-white lg:hidden"
    >
      {TABS.map((tab) =>
        tab.href === "/panier" ? (
          <Link
            key={tab.href}
            to={tab.href}
            aria-label={`Panier (${cartItemCount})`}
            className="relative flex flex-col items-center justify-center gap-0.5 py-2 font-body text-[10px] font-semibold text-navy"
          >
            <span className="relative -mt-6 flex h-11 w-11 items-center justify-center rounded-full bg-gold shadow-md">
              <span aria-hidden="true" className="text-lg leading-none text-navy">
                {tab.icon}
              </span>
              <CartCountBadge count={cartItemCount} tone="navy" className="absolute -right-1 -top-1 h-4 min-w-4 px-1 text-[9px]" />
            </span>
            {tab.label}
          </Link>
        ) : (
          <Link
            key={tab.href}
            to={tab.href}
            className="flex flex-col items-center justify-center gap-0.5 py-2 font-body text-[10px] text-navy"
          >
            <span aria-hidden="true" className="text-lg leading-none">
              {tab.icon}
            </span>
            {tab.label}
          </Link>
        ),
      )}
    </nav>
  );
}
